import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import {
  FindCertificateByIdResponseDto,
  useFindCertificateById,
} from "~/gen/api"

export function useCertificateDeepLink(
  onResolved: (c: FindCertificateByIdResponseDto) => void
) {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("certificateId") ?? ""
  const [resolvedCertificateId, setResolvedCertificateId] =
    useState<string | null>(null)

  const { data } = useFindCertificateById(id, {
    query: { enabled: id.length > 0 && resolvedCertificateId !== id },
  })

  useEffect(() => {
    const cert = data?.data
    if (!cert || cert.id !== id || resolvedCertificateId === id) return
    setResolvedCertificateId(id)
    onResolved(cert)
  }, [data, id, onResolved, resolvedCertificateId])
}
